import { Badge, Tooltip } from '@mantine/core';
import { useI18n } from '@/shared/i18n';

export function CompactDirectionBadge({ direction }: { direction: 'Debit' | 'Credit' | string }) {
  const { t } = useI18n();
  const isCredit = direction === 'Credit';
  const short = isCredit ? t('common.direction.shortCredit') : t('common.direction.shortDebit');
  const full = isCredit ? t('common.direction.credit') : t('common.direction.debit');

  return (
    <Tooltip label={full} withArrow>
      <Badge variant="light" color={isCredit ? 'teal' : 'orange'} size="sm" radius="sm" fw={700}>
        {short}
      </Badge>
    </Tooltip>
  );
}
